$(document).ready(function () {

	//set cookie to open warning modal
	if (Cookies.get('modal_shown') == null) {
        Cookies.set('modal_shown', 'yes', { expires: 30, path: '/' });
        $('#gpOnly').css('display', 'flex');
    }
	//Toggle treatments open and close
	$('.treatment__header').click(function(e) {
		e.preventDefault();
		$(this).closest('.treatment').toggleClass('treatment--active');
		// On open of treatment set data attr to current selected risk - to be used for only showing outcomes related to that risk
		var myRisk = $(this).closest('.treatment').find('.toggle-risk').val();
		$(this).closest('.treatment').attr('data-risk', myRisk);
	});

	// Toggle between Benefits and harms
	$('.data-tabs__tab--harms').click(function () {
		$(this).closest('.data').find('.data__panel--benefits').removeClass('data__panel--active');
		$(this).closest('.data').find('.data__panel--harms').addClass('data__panel--active');
		$(this).addClass('data-tabs__tab--active');
		$(this).attr('disabled', true);
		$(this).closest('.data').find('.data-tabs__tab--benefits').removeClass('data-tabs__tab--active');
		$(this).closest('.data').find('.data-tabs__tab--benefits').attr('disabled', false);
	});

	$('.data-tabs__tab--benefits').click(function () {
		$(this).closest('.data').find('.data__panel--benefits').addClass('data__panel--active');
		$(this).closest('.data').find('.data__panel--harms').removeClass('data__panel--active');
		$(this).addClass('data-tabs__tab--active');
		$(this).attr('disabled', true);
		$(this).closest('.data').find('.data-tabs__tab--harms').removeClass('data-tabs__tab--active');
		$(this).closest('.data').find('.data-tabs__tab--harms').attr('disabled', false);
	});

	// Set risk dropdown to static if only one

	//cycle through each risk dropdown (first one)
	$('.toggle-risk').each(function () {
		// get the amount of topions in the dropdown
		var optionCount = $(this).find('option').length;
		// if there are less than 3 - this will include please select null option so basically askiing if only one option
		if (optionCount < 3) {
			// get the text content of the last (only) option
			var optionVal = $(this).find('option:last-child').text();
			// Sets the dropdown value to the text of the last (only) option - WHY AGAIN?
			$(this).val(optionVal);
			// Create a P tag after the dropdown with the content of the only dropdown 
			$(this).after('<p class="risk-single">' + optionVal + '</p>');
			//hide the risk dropdown
			$(this).hide();

			// Get the value of the first dropdown
			var myVal = $(this).val();
			// Get the value of the second dropdown
			var selectedOutcome = $(this).closest('.data__panel').find('.toggle-outcomes').val();
			// Show second dropdown
			$(this).closest('.data').find('.data-filters__group--hidden').show();
			//Hide the placeholder chart
			$(this).closest(".data").find(".data__item--placeholder").hide();
			// cycle each chart group in this section
			$(this).closest('.data').find('.data__item--filled').each(function () {
				// Get the data attribue value for risk
				var myRisk = $(this).data('risk');
				// Get the data attribue value for outcome
				var myOutcome = $(this).data('outcome');
				// Hide this chart group
				$(this).hide();
				// If chart risk attribute equals the current risk value - IS THIS SET AS NO SELECTION IS MADE YET?
				//AND
				// if chart outcome attribue equals current outcome value
				if (myRisk == myVal && myOutcome == selectedOutcome) {
					// Show chart
					$(this).show();
				}
			});

			// if outcomes has only one item
			var myOutcomes = $(this).closest('.data').find('.toggle-outcomes option').length;
			// $(this).closest('.data').find('.toggle-outcomes').hide();
			console.log('number of outcomes is ' + myOutcomes);
			if (myOutcomes < 2) {
				// get item value
				var outcomeOptionVal = $(this).closest('.data').find('.toggle-outcomes option:last-child').text();

				// add p tag with that value
				$(this).closest('.data').find('.toggle-outcomes').after('<p class="outcome-single">' + outcomeOptionVal + '</p>');
				// remove outcomes select
				$(this).closest('.data').find('.toggle-outcomes').hide();
				$(this).closest('.data').find('.data__item--filled').show();

			}
		}
	});


	// Toggle Conditions
	$('.toggle-risk').change(function () {
		// reset dropdown if been changed
		$(this).closest('.data').find('.toggle-outcomes').show();
		$(this).closest('.data').find('.outcome-single').remove();

		// Get .toggle-risk dropdown value
		var myVal = $(this).val();

		// Get .toggle-outcomes dropdown value
		var selectedOutcome = $(this).closest('.data__panel').find('.toggle-outcomes').val();

		// set data risk of treatment to .toggle-risk value
		$(this).closest('.treatment').attr('data-risk', myVal);

		if (myVal === 'null') {
			$(this).closest('.data').find('.data__item--placeholder').show();
			$(this).closest('.data').find('.data-filters__group--hidden').hide();
			$(this).closest('.data').find('.data__item--filled').hide();
		}
		else {
			$(this).closest('.data').find('.data-filters__group--hidden').show();
			$(this).closest('.data').find('.data__item--placeholder').hide();
			$(this).closest('.data').find('.data__item--filled').each(function () {
				var myRisk = $(this).data('risk');
				var myOutcome = $(this).data('outcome');
				$(this).hide();
				if (myRisk == myVal && myOutcome == selectedOutcome) {
					$(this).show();
				}
			});
		}

		$(this).closest('.treatment').find('.toggle-outcomes > option').each(function () {
			var relatedrisk = $(this).attr('data-myrisk');
			if ( relatedrisk === myVal ) {
				$(this).show();
				$(this).addClass('outcome-active');
			}
			else {
				$(this).hide();
				$(this).removeClass('outcome-active');
			}
		});

		$(this).closest('.treatment').find('.toggle-outcomes').val(
			$(this).closest('.data').find('.toggle-outcomes option.outcome-active:first').val()
		);

		console.log('this' + $(this).closest('.data').find('.toggle-outcomes').val());

		var myVal = $(this).val(); //value of outcome - Nope! its the value of risk (again)

		var selectedOutcome = $(this).closest('.data__panel').find('.toggle-outcomes').val(); // value of risk
		if (selectedOutcome === 'null') {
			$(this).closest('.data').find('.data__item--placeholder').show();
			$(this).closest('.data').find('.data-filters__group--hidden').hide();
			$(this).closest('.data').find('.data__item--filled').hide();
		}
		else {
			$(this).closest('.data').find('.data-filters__group--hidden').show();
			$(this).closest('.data').find('.data__item--placeholder').hide();
			$(this).closest('.data').find('.data__item--filled').each(function () {
				var myRisk = $(this).data('risk');
				var myOutcome = $(this).data('outcome');
				$(this).hide();
				console.log('selected outcome: ' + selectedOutcome);
				console.log('selected risk: ' + myVal);
				console.log('My Risk: ' + myRisk);
				console.log('My Outcome: ' + myOutcome);
				if (myOutcome == selectedOutcome && myRisk == myVal) {
					$(this).show();
				}
			});
		}
		
		// if outcomes has only one item
		var myOutcomes = $(this).closest('.data').find('.toggle-outcomes .outcome-active').length;
		console.log('number of outcomes is ' + myOutcomes);
		if (myOutcomes < 2) {
			console.log('less than 2');
			// get item value
			var optionVal = $(this).closest('.data').find('.toggle-outcomes option:last-child').text();

			// add p tag with that value
			$(this).closest('.data').find('.toggle-outcomes').after('<p class="outcome-single">' + optionVal + '</p>');
			// remove outcomes select
			$(this).closest('.data').find('.toggle-outcomes').hide();
		}
	});

	// END Toggle Conditions

	$('.toggle-outcomes').change(function () {
		var myVal = $(this).val();
		var selectedRisk = $(this).closest('.data__panel').find('.toggle-risk').val();
		if (myVal === 'null') {
			$(this).closest('.data').find('.data__item--placeholder').show();
			$(this).closest('.data').find('.data-filters__group--hidden').hide();
			$(this).closest('.data').find('.data__item--filled').hide();
		}
		else {
			$(this).closest('.data').find('.data-filters__group--hidden').show();
			$(this).closest('.data').find('.data__item--placeholder').hide();
			$(this).closest('.data').find('.data__item--filled').each(function () {
				var myRisk = $(this).data('risk');
				var myOutcome = $(this).data('outcome');
				$(this).hide();
				console.log('selected outcome: ' + myVal);
				console.log('selected risk: ' + selectedRisk);
				console.log('My Risk: ' + myRisk);
				console.log('My Outcome: ' + myOutcome);
				if (myOutcome == myVal && myRisk == selectedRisk) {
					$(this).show();
				}
			});
		}
	});



	// Select all links with hashes
	$('a[href*="#"]')
	// Remove links that don't actually link to anything
	.not('[href="#"]')
	.not('[href="#0"]')
	.click(function(event) {
		// On-page links
		if (
		location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
		&& 
		location.hostname == this.hostname
		) {
		// Figure out element to scroll to
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
		// Does a scroll target exist?
		if (target.length) {
			console.log('hello1');
			// Only prevent default if animation is actually gonna happen
			event.preventDefault();
			$('html, body').animate({
			scrollTop: target.offset().top
			}, 1000, function() {
				// Callback after animation
				// Must change focus!
				var $target = $(target);
				$target.focus();
				if ($target.is(":focus")) { // Checking if the target was focused
					return false;
				} else {
					$target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
					$target.focus(); // Set focus again
				};
				console.log('hello');
				$target.closest('.treatment').addClass('treatment--active');
			});
		}
		}
	});

	// open modals
	$('.launch').click(function (e) {
		e.preventDefault();
		var target = $(this).data('launch');
		$(target).css('display', 'flex');
	});

	// close modals
	$('.modal__close').click(function (e) {
		e.preventDefault();
		$('.modal').css('display', 'none');
	});

	$('.modal__overlay').click(function (e) {
		e.preventDefault();
		$('.modal').css('display', 'none');
	});

	$('.modal__agree').click(function (e) {
		e.preventDefault();
		$('.modal').css('display', 'none');
	});

	// open 'more' items
	$('.more__hidden').hide();
	$('.more__trigger').click(function (e) {
		e.preventDefault();
		$(this).next().slideToggle();
		var text = $(this).text();
		$(this).text(text == 'Less' ? 'More' : 'Less');
	});

	// open conditions if linked to them
	if(window.location.hash) {
		var hash = window.location.hash;
		$(hash).closest('.treatment').addClass('treatment--active');
		$('html, body').animate({
			scrollTop: $(hash).offset().top
		}, 1500, 'swing');
	}
});
